<template>
  <el-dialog :title="dialogTitle" :visible.sync="visible" width="800px" top="5vh" :close-on-click-modal="false" custom-class="bond-form-dialog">
    <el-form ref="formRef" :model="form" :rules="rules" label-position="top" class="bond-form">
      <!-- 一、进口商信息 -->
      <div class="form-section">
        <div class="section-title">进口商信息</div>

        <!-- 主体信息 -->
        <div class="sub-section-title">主体信息</div>
        <div class="field-group">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="合作清关行" prop="customsBrokerId">
                <el-select
                  v-model="form.customsBrokerId"
                  placeholder="请输入清关行名称搜索"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  :remote-method="searchCustomsBrokers"
                  :loading="brokerLoading"
                  style="width: 100%"
                  @change="handleBrokerChange"
                  @clear="handleBrokerClear"
                  @visible-change="handleBrokerVisibleChange"
                  @input.native="handleBrokerSearchInput"
                >
                  <el-option v-for="item in customsBrokers" :key="item.cmpIdx" :label="item.chineseName" :value="item.cmpIdx" />
                  <div v-if="brokerHasMore" class="load-more-tip">滚动到底部加载更多...</div>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Importer No" prop="importerNo">
                <el-input v-model="form.importerNo" placeholder="请输入Importer No" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="进口商名称" prop="importerName">
                <el-input v-model="form.importerName" placeholder="请输入进口商名称" />
              </el-form-item>
            </el-col>
          </el-row>

          <div class="sub-section-title">实际经营地址（美国）</div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="洲/省" prop="operatingState">
                <el-select v-model="form.operatingState" placeholder="请选择" style="width: 100%" filterable clearable @change="handleStateChange('operating')" @clear="handleStateClear('operating')">
                  <el-option v-for="item in usStates" :key="item.stateCode" :label="item.stateName" :value="item.stateName" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="城市" prop="operatingCity">
                <el-select v-model="form.operatingCity" placeholder="请选择" style="width: 100%" filterable clearable>
                  <el-option v-for="item in operatingCities" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="详细街道地址" prop="operatingAddress">
                <el-input v-model="form.operatingAddress" placeholder="请输入详细街道地址" />
              </el-form-item>
            </el-col>
          </el-row>

          <div class="sub-section-title-row">
            <span class="sub-section-title">邮寄地址（美国）</span>
            <el-checkbox v-model="form.mailingSame" @change="handleMailingSame">和实际地址保持一致</el-checkbox>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="洲/省" prop="mailingState">
                <el-select v-model="form.mailingState" placeholder="请选择" style="width: 100%" :disabled="form.mailingSame" filterable clearable @change="handleStateChange('mailing')" @clear="handleStateClear('mailing')">
                  <el-option v-for="item in usStates" :key="item.stateCode" :label="item.stateName" :value="item.stateName" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="城市" prop="mailingCity">
                <el-select v-model="form.mailingCity" placeholder="请选择" style="width: 100%" :disabled="form.mailingSame" filterable clearable>
                  <el-option v-for="item in mailingCities" :key="item" :label="item" :value="item" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="详细街道地址" prop="mailingAddress">
                <el-input v-model="form.mailingAddress" placeholder="请输入详细街道地址" :disabled="form.mailingSame" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 备案信息 -->
        <div class="sub-section-title filing-title">备案信息</div>
        <div class="field-group">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="法人/授权负责人姓名" prop="legalPersonName">
                <el-input v-model="form.legalPersonName" placeholder="请输入法人/授权负责人姓名" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="contactPhone">
                <el-input v-model="form.contactPhone" placeholder="请输入联系电话" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Email" prop="email">
                <el-input v-model="form.email" placeholder="请输入Email" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="EIN税号" prop="einTaxNo">
                <el-input v-model="form.einTaxNo" placeholder="请输入EIN税号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="ACE 用户名" prop="aceUsername">
                <el-input v-model="form.aceUsername" placeholder="请输入ACE用户名" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="ACE 密码" prop="acePassword">
                <el-input v-model="form.acePassword" placeholder="请输入ACE密码" type="password" show-password />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 二、美国清关Bond核心信息 -->
      <div class="form-section">
        <div class="section-title">美国清关Bond核心信息</div>
        <div class="field-group">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="Bond类型" prop="bondType">
                <el-select v-model="form.bondType" placeholder="请选择" style="width: 100%">
                  <el-option label="年度Continuous Bond" value="1" />
                  <el-option label="单次STB Bond" value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Bond编号" prop="bondNo">
                <el-input v-model="form.bondNo" placeholder="请输入Bond编号" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="担保公司/人" prop="guarantor">
                <el-input v-model="form.guarantor" placeholder="请输入担保公司/人" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="备案港口" prop="registerPorts">
                <el-select
                  v-model="form.registerPorts"
                  placeholder="请输入港口名称搜索"
                  filterable
                  remote
                  clearable
                  multiple
                  collapse-tags
                  reserve-keyword
                  :remote-method="searchSeaPorts"
                  :loading="seaPortLoading"
                  style="width: 100%"
                  @visible-change="handleSeaPortVisibleChange"
                  @clear="handleSeaPortClear"
                  @input.native="handleSeaPortSearchInput"
                >
                  <el-option v-for="item in seaPorts" :key="item.code" :label="item.code + ' ' + (item.chineseName || item.englishName)" :value="item.code" />
                  <div v-if="seaPortHasMore" class="load-more-tip">滚动到底部加载更多...</div>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Bond金额(USD)" prop="bondAmount">
                <el-input-number v-model="form.bondAmount" placeholder="请输入Bond金额" :precision="2" :step="0.01" :min="0" style="width: 100%" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="生效日期" prop="effectiveDate">
                <el-date-picker v-model="form.effectiveDate" type="date" placeholder="请选择生效日期" style="width: 100%" value-format="yyyy/MM/dd" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="到期日期" prop="expiryDate">
                <el-date-picker v-model="form.expiryDate" type="date" placeholder="请选择到期日期" style="width: 100%" value-format="yyyy/MM/dd" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="isEdit && expiryDateChanged" :gutter="20">
            <el-col :span="24">
              <el-form-item label="续保修订说明" prop="renewalDesc">
                <el-input v-model="form.renewalDesc" type="textarea" :rows="2" placeholder="请输入续保修订说明" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 三、附件与内部备注 -->
      <div class="form-section">
        <div class="section-title">附件与内部备注</div>
        <el-form-item label="上传Bond合同文件">
          <div class="upload-area">
            <el-upload
              action=""
              :http-request="customUpload"
              :on-change="handleFileChange"
              :before-upload="beforeUpload"
              multiple
              :show-file-list="false"
            >
              <div class="upload-btn">
                <i class="el-icon-plus" />
                <span>+ 添加附件(备注:当前支持PDF、WORD、EXCEL、TXT、JPG文件格式)</span>
              </div>
            </el-upload>
          </div>
          <div v-if="fileList.length > 0" class="file-list">
            <div v-for="(file, index) in fileList" :key="index" class="file-item">
              <span class="file-name">
                <i v-if="file.status === 'uploading'" class="el-icon-loading" />
                {{ file.name }}
              </span>
              <span v-if="file.status === 'success'" class="file-actions">
                <el-button size="mini" type="primary" plain @click="downloadFile(file)">下载</el-button>
                <el-button size="mini" type="primary" plain @click="previewFile(file)">预览</el-button>
                <el-button size="mini" type="danger" @click="removeFile(file, index)">删除</el-button>
              </span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="内部通用备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="对接人、客户特殊要求等通用备注" />
        </el-form-item>
      </div>
    </el-form>
    <bond-preview-dialog
      :visible.sync="previewVisible"
      :file-id="previewFileId"
      :file-name="previewFileName"
      :file-format="previewFileFormat"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveBond, updateBond, bondUploadStorage, bondFindByFileId, bondGetFileInfo, getUsStates, getUsCitiesByState } from '@/api/bondManagement'
import { getCompanyListByType } from '@/api/company'
import { getSeaPortList } from '@/api/seaport'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import BondPreviewDialog from './BondPreviewDialog'

export default {
  name: 'BondForm',
  components: {
    BondPreviewDialog
  },
  data() {
    return {
      visible: false,
      mode: 'add',
      form: {
        uuid: '',
        customsBrokerId: '',
        customsBrokerName: '',
        importerNo: '',
        importerName: '',
        operatingState: '',
        operatingCity: '',
        operatingAddress: '',
        mailingSame: false,
        mailingState: '',
        mailingCity: '',
        mailingAddress: '',
        legalPersonName: '',
        contactPhone: '',
        email: '',
        einTaxNo: '',
        aceUsername: '',
        acePassword: '',
        bondType: '1',
        bondNo: '',
        guarantor: '',
        registerPorts: [],
        bondAmount: '',
        effectiveDate: '',
        expiryDate: '',
        remark: '',
        fileUrls: [],
        renewalDesc: ''
      },
      originalExpiryDate: '',
      expiryDateChanged: false,
      customsBrokers: [],
      brokerLoading: false,
      brokerPageNum: 1,
      brokerPageSize: 20,
      brokerHasMore: true,
      brokerSearchKey: '',
      brokerLastInput: '',
      brokerScrollTarget: null,
      seaPorts: [],
      seaPortLoading: false,
      seaPortPageNum: 1,
      seaPortPageSize: 20,
      seaPortHasMore: true,
      seaPortSearchKey: '',
      seaPortLastInput: '',
      seaPortScrollTarget: null,
      usStates: [],
      operatingCities: [],
      mailingCities: [],
      fileList: [],
      previewVisible: false,
      previewFileId: '',
      previewFileName: '',
      previewFileFormat: '',
      rules: {
        importerNo: [{ required: true, message: 'Importer No不能为空' }],
        bondType: [{ required: true, message: 'Bond类型不能为空' }],
        bondNo: [{ required: true, message: 'Bond编号不能为空' }],
        bondAmount: [{ required: true, message: 'Bond金额不能为空' }],
        effectiveDate: [{ required: true, message: '生效日期不能为空' }],
        expiryDate: [{ required: true, message: '到期日期不能为空' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.mode === 'add' ? '新增美国清关Bond档案' : '编辑美国清关Bond档案'
    },
    isEdit() {
      return this.mode === 'edit'
    }
  },
  watch: {
    'form.expiryDate'(newVal) {
      if (this.isEdit && this.originalExpiryDate && newVal !== this.originalExpiryDate) {
        this.expiryDateChanged = true
      } else {
        this.expiryDateChanged = false
      }
    }
  },
  mounted() {
    this.loadCustomsBrokers()
    this.loadSeaPorts()
  },
  methods: {
    show(mode, row = null) {
      this.mode = mode
      this.form = {
        uuid: '',
        customsBrokerId: '',
        customsBrokerName: '',
        importerNo: '',
        importerName: '',
        operatingState: '',
        operatingCity: '',
        operatingAddress: '',
        mailingSame: false,
        mailingState: '',
        mailingCity: '',
        mailingAddress: '',
        legalPersonName: '',
        contactPhone: '',
        email: '',
        einTaxNo: '',
        aceUsername: '',
        acePassword: '',
        bondType: '1',
        bondNo: '',
        guarantor: '',
        registerPorts: [],
        bondAmount: '',
        effectiveDate: '',
        expiryDate: '',
        remark: '',
        fileUrls: [],
        renewalDesc: ''
      }
      // 重置分页状态
      this.brokerPageNum = 1
      this.brokerSearchKey = ''
      this.brokerLastInput = ''
      this.brokerHasMore = true
      // 新增模式下清空清关行下拉数据，避免编辑数据残留
      if (mode === 'add') {
        this.customsBrokers = []
      }
      this.seaPortPageNum = 1
      this.seaPortSearchKey = ''
      this.seaPortLastInput = ''
      this.seaPortHasMore = true
      this.expiryDateChanged = false
      this.fileList = []
      this.operatingCities = []
      this.mailingCities = []
      // 加载美国州列表，加载完成后再处理编辑回显的城市
      this.loadUsStates().then(() => {
        if (row) {
          if (this.form.operatingState) {
            this.loadCitiesForEdit('operating', this.form.operatingState)
          }
          if (this.form.mailingState) {
            this.loadCitiesForEdit('mailing', this.form.mailingState)
          }
        }
      })

      if (row) {
        Object.assign(this.form, row)
        this.originalExpiryDate = row.expiryDate ? row.expiryDate.substring(0, 10).replace(/-/g, '/') : ''
        // 日期格式转换：后端返回 yyyy-MM-dd HH:mm:ss，控件需要 yyyy/MM/dd
        if (this.form.effectiveDate) {
          this.form.effectiveDate = this.form.effectiveDate.substring(0, 10).replace(/-/g, '/')
        }
        if (this.form.expiryDate) {
          this.form.expiryDate = this.form.expiryDate.substring(0, 10).replace(/-/g, '/')
        }
        // 将逗号分隔字符串转为数组（后端存储格式为逗号分隔字符串）
        this.form.fileUrls = row.fileUrls
          ? (typeof row.fileUrls === 'string' ? row.fileUrls.split(',') : [...row.fileUrls])
          : []
        this.form.registerPorts = row.registerPorts
          ? (typeof row.registerPorts === 'string' ? row.registerPorts.split(',') : [...row.registerPorts])
          : []
        if (this.form.fileUrls.length > 0) {
          this.fileList = this.form.fileUrls.map(fileId => ({ name: fileId, fileId, status: 'success' }))
          // 通过 fileId 获取文件名
          this.form.fileUrls.forEach((fileId, index) => {
            bondGetFileInfo(fileId).then(res => {
              if (res.data && res.data.fileName) {
                this.fileList[index].name = res.data.fileName
              }
            }).catch(() => {
              // 获取失败保持 fileId 作为名称
            })
          })
        }
        // 编辑回显：将已选清关行放入下拉列表，确保显示名称
        if (row.customsBrokerId && row.customsBrokerName) {
          this.customsBrokers = [{ cmpIdx: row.customsBrokerId, chineseName: row.customsBrokerName }]
          this.brokerHasMore = false
        }
        // 编辑回显：预先加载港口数据，确保已选港口显示中文名称
        if (this.form.registerPorts.length > 0) {
          this.loadAllSeaPortsForEdit()
        }
      }
      this.visible = true
      // 清除表单校验状态，避免弹窗打开时立即显示校验错误
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    async loadUsStates() {
      try {
        const res = await getUsStates()
        this.usStates = res.data || []
      } catch (e) {
        console.error('加载美国州列表失败', e)
        this.usStates = []
      }
    },
    async loadCitiesForEdit(type, stateName) {
      const stateObj = this.usStates.find(s => s.stateName === stateName)
      if (!stateObj) return
      try {
        const res = await getUsCitiesByState(stateObj.stateCode)
        const list = (res.data || []).map(item => item.cityName)
        if (type === 'operating') {
          this.operatingCities = list
        } else {
          this.mailingCities = list
        }
      } catch (e) {
        console.error('编辑回显加载城市失败', e)
      }
    },
    async handleStateChange(type) {
      const stateName = type === 'operating' ? this.form.operatingState : this.form.mailingState
      // 通过州名查找对应的 stateCode
      const stateObj = this.usStates.find(s => s.stateName === stateName)
      if (type === 'operating') {
        this.form.operatingCity = ''
        this.operatingCities = []
      } else {
        this.form.mailingCity = ''
        this.mailingCities = []
      }
      if (!stateObj) return
      try {
        const res = await getUsCitiesByState(stateObj.stateCode)
        const list = (res.data || []).map(item => item.cityName)
        if (type === 'operating') {
          this.operatingCities = list
        } else {
          this.mailingCities = list
        }
      } catch (e) {
        console.error('加载城市失败', e)
      }
    },
    handleStateClear(type) {
      if (type === 'operating') {
        this.form.operatingCity = ''
        this.operatingCities = []
      } else {
        this.form.mailingCity = ''
        this.mailingCities = []
      }
    },
    handleMailingSame() {
      if (this.form.mailingSame) {
        this.form.mailingState = this.form.operatingState
        this.form.mailingCity = this.form.operatingCity
        this.form.mailingAddress = this.form.operatingAddress
        this.mailingCities = [...this.operatingCities]
      }
    },
    async loadCustomsBrokers(reset = true, forceReset = false) {
      if (this.brokerLoading) return
      this.brokerLoading = true
      try {
        if (reset) {
          this.brokerPageNum = 1
          this.brokerHasMore = true
        }
        const params = {
          type: 'customsBroker',
          active: true,
          likeName: this.brokerSearchKey,
          pageNum: this.brokerPageNum,
          pageSize: this.brokerPageSize
        }
        const res = await getCompanyListByType(params)
        const list = (res.data && res.data.list) || []
        if (reset) {
          if (forceReset) {
            this.customsBrokers = list
          } else if (this.form.customsBrokerId && this.form.customsBrokerName && this.customsBrokers.length === 1) {
            this.customsBrokers = this.customsBrokers.concat(list)
          } else {
            this.customsBrokers = list
          }
        } else {
          this.customsBrokers = this.customsBrokers.concat(list)
        }
        const total = (res.data && res.data.total) || 0
        this.brokerHasMore = this.customsBrokers.length < total
      } catch (e) {
        console.error('加载清关行失败:', e)
      } finally {
        this.brokerLoading = false
      }
    },
    searchCustomsBrokers(query) {
      if (!query && this.brokerSearchKey) {
        this.brokerSearchKey = ''
        this.loadCustomsBrokers(true, true)
        return
      }
      this.brokerSearchKey = query
      this.loadCustomsBrokers(true)
    },
    handleBrokerSearchInput(e) {
      const val = e.target.value
      const wasNotEmpty = this.brokerLastInput !== ''
      this.brokerLastInput = val
      if (!val && wasNotEmpty) {
        this.brokerSearchKey = ''
        this.loadCustomsBrokers(true, true)
      }
    },
    handleBrokerChange(val) {
      const selected = this.customsBrokers.find(item => item.cmpIdx === val)
      if (selected) {
        this.form.customsBrokerName = selected.chineseName
      } else {
        this.form.customsBrokerName = ''
      }
    },
    handleBrokerClear() {
      this.form.customsBrokerName = ''
      this.customsBrokers = []
      this.brokerSearchKey = ''
      this.brokerLastInput = ''
      this.loadCustomsBrokers(true, true)
    },
    handleBrokerVisibleChange(visible) {
      if (visible) {
        this.$nextTick(() => {
          this.bindBrokerScroll()
          if (!this.customsBrokers.length) {
            this.brokerSearchKey = ''
            this.loadCustomsBrokers(true)
          }
        })
      } else {
        this.unbindBrokerScroll()
        this.brokerSearchKey = ''
        this.brokerLastInput = ''
      }
    },
    bindBrokerScroll() {
      this.unbindBrokerScroll()
      const dropdowns = document.querySelectorAll('.el-select-dropdown__wrap')
      if (dropdowns.length === 0) return
      const currentDropdown = dropdowns[dropdowns.length - 1]
      currentDropdown.addEventListener('scroll', this.handleBrokerScroll)
      this.brokerScrollTarget = currentDropdown
    },
    unbindBrokerScroll() {
      if (this.brokerScrollTarget) {
        this.brokerScrollTarget.removeEventListener('scroll', this.handleBrokerScroll)
        this.brokerScrollTarget = null
      }
    },
    handleBrokerScroll(e) {
      const target = e.target
      if (target.scrollHeight - target.scrollTop - target.clientHeight < 10 && this.brokerHasMore && !this.brokerLoading) {
        this.brokerPageNum++
        this.loadCustomsBrokers(false)
      }
    },
    async loadAllSeaPortsForEdit() {
      try {
        const res = await getSeaPortList({
          likeName: '',
          pageNum: 1,
          pageSize: 1000
        })
        const list = (res.data && res.data.list) || []
        this.seaPorts = list
      } catch (e) {
        console.error('加载港口失败:', e)
      }
    },
    async loadSeaPorts(reset = true) {
      if (this.seaPortLoading) return
      this.seaPortLoading = true
      try {
        if (reset) {
          this.seaPortPageNum = 1
          this.seaPortHasMore = true
        }
        const params = {
          likeName: this.seaPortSearchKey,
          pageNum: this.seaPortPageNum,
          pageSize: this.seaPortPageSize
        }
        const res = await getSeaPortList(params)
        const list = (res.data && res.data.list) || []
        if (reset) {
          this.seaPorts = list
        } else {
          this.seaPorts = this.seaPorts.concat(list)
        }
        const total = (res.data && res.data.total) || 0
        this.seaPortHasMore = this.seaPorts.length < total
      } catch (e) {
        console.error('加载港口失败:', e)
      } finally {
        this.seaPortLoading = false
      }
    },
    searchSeaPorts(query) {
      if (!query && this.seaPortSearchKey) {
        this.seaPortSearchKey = ''
        this.loadSeaPorts(true)
        return
      }
      this.seaPortSearchKey = query
      this.loadSeaPorts(true)
    },
    handleSeaPortSearchInput(e) {
      const val = e.target.value
      const wasNotEmpty = this.seaPortLastInput !== ''
      this.seaPortLastInput = val
      if (!val && wasNotEmpty) {
        this.seaPortSearchKey = ''
        this.loadSeaPorts(true)
      }
    },
    handleSeaPortClear() {
      this.seaPorts = []
      this.seaPortSearchKey = ''
      this.seaPortLastInput = ''
      this.loadSeaPorts(true)
    },
    handleSeaPortVisibleChange(visible) {
      if (visible) {
        this.$nextTick(() => {
          this.bindSeaPortScroll()
          if (!this.seaPorts.length) {
            this.seaPortSearchKey = ''
            this.loadSeaPorts(true)
          }
        })
      } else {
        this.unbindSeaPortScroll()
        this.seaPortSearchKey = ''
        this.seaPortLastInput = ''
      }
    },
    bindSeaPortScroll() {
      this.unbindSeaPortScroll()
      const dropdowns = document.querySelectorAll('.el-select-dropdown__wrap')
      if (dropdowns.length === 0) return
      const currentDropdown = dropdowns[dropdowns.length - 1]
      currentDropdown.addEventListener('scroll', this.handleSeaPortScroll)
      this.seaPortScrollTarget = currentDropdown
    },
    unbindSeaPortScroll() {
      if (this.seaPortScrollTarget) {
        this.seaPortScrollTarget.removeEventListener('scroll', this.handleSeaPortScroll)
        this.seaPortScrollTarget = null
      }
    },
    handleSeaPortScroll(e) {
      const target = e.target
      if (target.scrollHeight - target.scrollTop - target.clientHeight < 10 && this.seaPortHasMore && !this.seaPortLoading) {
        this.seaPortPageNum++
        this.loadSeaPorts(false)
      }
    },
    async customUpload(options) {
      const { file } = options
      const fileItem = {
        name: file.name,
        fileId: '',
        status: 'uploading'
      }
      this.fileList.push(fileItem)
      try {
        const res = await bondUploadStorage({ file })
        fileItem.fileId = res.data || res
        fileItem.status = 'success'
        this.form.fileUrls.push(fileItem.fileId)
      } catch (e) {
        fileItem.status = 'fail'
        this.$message.error('文件上传失败: ' + file.name)
      }
    },
    handleFileChange() {
      // 文件变化回调，空实现（自定义上传）
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      return isLt10M
    },
    downloadFile(file) {
      bondFindByFileId(file.fileId).then(res => {
        const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      }).catch(() => {
        this.$message.error('文件下载失败')
      })
    },
    previewFile(file) {
      this.previewFileId = file.fileId
      this.previewFileName = file.name
      this.previewFileFormat = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      this.previewVisible = true
    },
    removeFile(file, index) {
      this.fileList.splice(index, 1)
      const urlIndex = this.form.fileUrls.indexOf(file.fileId)
      if (urlIndex > -1) {
        this.form.fileUrls.splice(urlIndex, 1)
      }
    },
    async handleSave() {
      this.$refs.formRef.validate(async(valid) => {
        if (!valid) {
          return
        }
        const loading = getLoading4Cxt(this)
        try {
          // 创建提交副本，将数组转为逗号分隔字符串（后端存储格式）
          const submitData = JSON.parse(JSON.stringify(this.form))
          // 日期格式转换：前端控件使用 yyyy/MM/dd，后端需要 yyyy-MM-dd
          if (submitData.effectiveDate) {
            submitData.effectiveDate = submitData.effectiveDate.replace(/\//g, '-')
          }
          if (submitData.expiryDate) {
            submitData.expiryDate = submitData.expiryDate.replace(/\//g, '-')
          }
          submitData.fileUrls = Array.isArray(this.form.fileUrls)
            ? this.form.fileUrls.join(',')
            : (this.form.fileUrls || '')
          submitData.registerPorts = Array.isArray(this.form.registerPorts)
            ? this.form.registerPorts.join(',')
            : (this.form.registerPorts || '')
          if (this.mode === 'add') {
            await saveBond(submitData)
          } else {
            await updateBond(submitData)
          }
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('save-success')
        } catch (e) {
          if (e.response && e.response.data && e.response.data.message) {
            this.$message.error(e.response.data.message)
          } else {
            this.$message.error('保存失败')
          }
        } finally {
          loading.close()
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.bond-form {
  .form-section {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
      border-bottom: none;
    }
  }

  .section-title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 18px;
    padding-left: 8px;
    border-left: 3px solid #409eff;
  }

  .sub-section-title {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 14px;
    padding-left: 2px;
  }

  /* 备案信息标题：与上方内容间距增加4px */
  .filing-title {
    margin-top: 4px;
  }

  /* 分组边框容器：主体信息、备案信息、Bond核心信息 */
  .field-group {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 18px 16px 0;
    margin-bottom: 18px;
  }

  .sub-section-title-row {
    display: flex;
    align-items: center;
    margin-bottom: 14px;

    .sub-section-title {
      margin-bottom: 0;
      margin-right: 20px;
    }
  }

  .upload-area {
    border: 2px dashed #d9d9d9;
    border-radius: 4px;
    padding: 15px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.3s;

    &:hover {
      border-color: #409eff;
    }
  }

  .upload-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 14px;

    .el-icon-plus {
      margin-right: 5px;
      font-size: 20px;
    }
  }

  .file-list {
    margin-top: 15px;
  }

  .file-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    background: #fafafa;
    border-radius: 4px;
    margin-bottom: 8px;
  }

  .file-name {
    font-size: 13px;
    color: #666;
  }

  .file-actions {
    .el-button {
      margin-left: 8px;
    }
  }

  /* 必填星号显示在标签后面 */
  ::v-deep .el-form-item__label {
    .el-form-item__label-content {
      display: inline;
    }
  }

  ::v-deep .el-form-item.is-required:not(.is-no-asterisk) {
    > .el-form-item__label {
      &::before {
        content: '' !important;
      }
      &::after {
        content: '*';
        color: #f56c6c;
        margin-left: 4px;
      }
    }
  }
}

.dialog-footer {
  text-align: right;
  display: block;
}

/* 弹窗内容区内部滚动：内容超出屏幕高度时在弹窗内滚动，保证所有字段可见 */
::v-deep .bond-form-dialog .el-dialog__body {
  max-height: 72vh;
  overflow-y: auto;
}

.load-more-tip {
  text-align: center;
  font-size: 12px;
  color: #909399;
  padding: 8px 0;
}
</style>
